import "./../../levels/common.blocks/header2/header2.react.js";
import _header2_border_transparent from "./../../levels/common.blocks/header2/_border/header2_border_transparent.react.js";

var Header = _header2_border_transparent.applyDecls();

import "./../../levels/common.blocks/header2/header2.css";
import "./../../levels/common.blocks/header2/_border/header2_border_transparent.css";
import "./../../levels/common.blocks/header2/_border/header2_border_white.css";
import "./../../levels/common.blocks/header2/_fixed/header2_fixed_yes.css";


export default Header;